module.exports = __webpack_public_path__ + "media/wrong.3dc30b2b.wav";